import React, { useMemo } from "react";
import SavePageView from "./SavePageView/SavePageView";
import ViewFiltersPanel from "./ViewFiltersPanel";
// import DownloadModal from "./DownloadModal/DownloadModal";
import SharePage from "./SharePage/SharePage";
import FilterButton from "./FilterButton/FIlterButton";
import "./Dashboard.scss";

interface DashboardHeaderProps {
  selectedLevel: "appLevel" | "roleLevel" | "featureLevel";
  filterValues: Array<{ title: string; value: string; id: number }>;
  setFilterValues: (
    values: Array<{ title: string; value: string; id: number }>,
  ) => void;
  sharePayload: Record<string, any>;
  shareEnv: string;
  onApplySavedView: (
    viewState: Record<string, any>,
    applyViewData?: boolean,
  ) => void;
  hasSharedLink?: boolean;
  onSavedViewInitResolved?: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  selectedLevel,
  filterValues,
  setFilterValues,
  sharePayload,
  shareEnv,
  onApplySavedView,
  hasSharedLink = false,
  onSavedViewInitResolved,
}) => {
  const formattedAsOf = useMemo(() => {
    const now = new Date();
    const time = now.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const date = now.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    return `as of ${time} on ${date}`;
  }, []);

  return (
    <>
      <div className="dashboard-header">
        <div className="flex-space-btw pd16">
          <div className="titleTime">
            <div className="dashboard-title-row">
              <span className="dashboard-title-label">
                Application Dashboard:
              </span>
            </div>
            <div className="dashboard-asof">{formattedAsOf}</div>
          </div>
          <div className="icons-group">
            <SharePage sharePayload={sharePayload} shareEnv={shareEnv} />
            <SavePageView
              viewStatePayload={sharePayload}
              onApplySavedView={onApplySavedView}
              hasSharedLink={hasSharedLink}
              onInitResolved={onSavedViewInitResolved}
            />
            {/* <DownloadModal /> */}
            <FilterButton
              selectedLevel={selectedLevel}
              filterValues={filterValues}
              setFilterValues={setFilterValues}
            />
          </div>
        </div>
        <div>
          <ViewFiltersPanel
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        </div>
      </div>
    </>
  );
};

export default DashboardHeader;
